import { render, staticRenderFns } from "./dashboardJinduJiankang.vue?vue&type=template&id=34a79098&scoped=true"
import script from "./dashboardJinduJiankang.vue?vue&type=script&lang=js"
export * from "./dashboardJinduJiankang.vue?vue&type=script&lang=js"
import style0 from "./dashboardJinduJiankang.vue?vue&type=style&index=0&id=34a79098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a79098",
  null
  
)

export default component.exports